import {
	API2_URL,
	PROJECT_DISPERSIONS_REQUEST,
	PROJECT_DISPERSIONS,
	PROJECT_DISPERSIONS_LOADED,
	PROJECT_DISPERSIONS_CLEAR,
	PROJECT_DISPERSIONS_FAIL
} from "../store/config";
import {sessionService} from "redux-react-session";
import fetch from "isomorphic-fetch";
import {newNotification} from "./notifications";
import _ from "lodash";
import FileSaver from "file-saver";

export const projectDispersions = (modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectDispersionsRequest());
			dispatch(projectDispersionsClear());

			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			}

			return fetch(`${API2_URL}/projects/agreements/budgets/${modality}/${state}${mun ? '/'+mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(projectDispersionsData(json)),
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectDispersionsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})

}

export const projectDispersionsExport = (modality, state, mun = undefined) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectDispersionsRequest());

			const options = {
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			}

			let fileName= undefined;

			return fetch(`${API2_URL}/projects/agreements/budgets/${modality}/${state}${mun ? '/'+mun : ''}?export=1`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						let header = result.headers.get('Content-Disposition','attachment')
						fileName = header.match(/filename="(.+)"/)[1];
						return result.blob();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					blob => {
						FileSaver.saveAs(blob,fileName);
						dispatch(projectDispersionsLoaded())
					},
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectDispersionsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})

}

export const projectDispersionsSave = (modality, state, mun = undefined, values) => (dispatch) => {
	let budgets = []

	_.map(values.budgets, (row) => {
		return budgets.push({project_id: row.project_id, dispersion_date: row.dispersion_date, method: row.method})
	})

	if(!_.isEmpty(budgets)){
		return dispatch(projectDispersionsEditSave(modality, state, mun, {...values, budgets: budgets}))
	}else {
		dispatch(newNotification({title:'¡Oh no!', content: 'Agregar al menos una instancia para guardar', type: 'danger'}))
		return dispatch(projectDispersionsFail('Agregar al menos una instancia para guardar'));
	}
}

const projectDispersionsEditSave = (modality, state, mun = undefined, values) => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(projectDispersionsRequest());
			let body = new FormData();

			_.mapKeys(values.budgets, (o,j) => {
				_.mapKeys(o, (item, k) => {
					if(item !== undefined){
						if(!_.isObject(item) &&  !_.startsWith(item, 'http://')){
							body.append(`budgets[${j}][${k}]`,item);
						}else if(_.isObject(item) && !_.isEmpty(item) && item[0] !== undefined) {
							body.append(`budgets[${j}][${k}]`,item[0]);
						}
					}
				})
			});

			_.mapKeys(values.documents, (o,j) => {
				if(o !== undefined) {
					if(!_.isObject(o) &&  !_.startsWith(o, 'http://')){
						body.append(j, o);
					}else if(_.isObject(o) && !_.isEmpty(o) && o[0] !== undefined) {
						body.append(j, o[0]);
					}
				}
			});

			/*if(values.tesofe_refound !== undefined){
				if(!_.isObject(values.tesofe_refound) &&  !_.startsWith(values.tesofe_refound, 'http://')){
					body.append(`tesofe_refound`,values.tesofe_refound);
				}else if(_.isObject(values.tesofe_refound) && !_.isEmpty(values.tesofe_refound) && values.tesofe_refound[0] !== undefined) {
					body.append(`tesofe_refound`,values.tesofe_refound[0]);
				}
			}

			if(values.budgets_dispersion_summary !== undefined){
				if(!_.isObject(values.budgets_dispersion_summary) &&  !_.startsWith(values.budgets_dispersion_summary, 'http://')){
					body.append(`budgets_dispersion_summary`,values.budgets_dispersion_summary);
				}else if(_.isObject(values.budgets_dispersion_summary) && !_.isEmpty(values.budgets_dispersion_summary) && values.budgets_dispersion_summary[0] !== undefined) {
					body.append(`budgets_dispersion_summary`,values.budgets_dispersion_summary[0]);
				}
			}*/

			const options = {
				headers: {
					'Accept': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'post',
				body: body
			}

			return fetch(`${API2_URL}/projects/agreements/budgets/${modality}/${state}${mun ? '/'+mun : ''}`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => {
						dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message: "La información de la dispersion se ha guardado correctamente", type:"success"}))
						return dispatch(projectDispersionsData(json))
					},
					error => {
						dispatch(newNotification({title:'¡Oh no!', content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: 'danger'}));
						return dispatch(projectDispersionsFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				)
		})
}

const projectDispersionsData = (json) => {
	let documents = {}; let list = [];
	let responseData = [];

	_.map(json.data.modalities, (mods) => {
		if(!_.isEmpty(mods.projects)){
			return _.map(mods.projects, (row) => {
				if(_.isEmpty(row.budget)){
					return list.push({
						modality_id: mods.id,
						modality_name: mods.name ? mods.name:'---',
						project_id:row.id,
						agency_name: row.agency.name,
						agenciable_name: row.agency.agenciable.name,
						amount:row.amounts ? row.amounts.total:0
					})
				}else {
					return responseData.push({
						modality_id: mods.id,
						modality_name: mods.name,
						project_id:row.id,
						agency_name: row.agency.name,
						agenciable_name: row.agency.agenciable.name,
						amount: row.amounts.total,
						dispersion_date: row.budget.dispersion_date,
						method: row.budget.method
					})
				}
			})
		}
	})

	if(json.data && !_.isEmpty(json.data.project) && !_.isEmpty(json.data.project.documents)){
		_.map(json.data.project.documents,(item) => {
			documents = {
				...documents,
				[item.documentable_subtype]: item.file
			}
		})
	}

	if(json.data && !_.isEmpty(json.data.agency) && !_.isEmpty(json.data.agency.documents)){
		_.map(json.data.agency.documents,(item) => {
			documents = {
				...documents,
				[item.documentable_subtype]: item.file
			}
		})
	}

	return {
		type: PROJECT_DISPERSIONS,
		isFetching: false,
		payload: {
			...json.data,
			budgets: responseData,
			list: list,
			documents: documents
		},
		documents_items: json.documents_items,
		editable: json.editable,
		revision: json.revision ? {
			...json.revision,
			body: JSON.parse(json.revision.body)
		}:{},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const projectDispersionsRequest = () => {
	return {
		type: PROJECT_DISPERSIONS_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const projectDispersionsLoaded = () => {
	return {
		type: PROJECT_DISPERSIONS_LOADED,
		isFetching: false,
		timestamp: Date.now()
	}
}

const projectDispersionsClear = () => {
	return {
		type: PROJECT_DISPERSIONS_CLEAR,
		payload: {
			list:[],
			budgets:[],
		},
		timestamp: Date.now()
	}
}

const projectDispersionsFail = (error) => {
	return {
		type: PROJECT_DISPERSIONS_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/dispersions.js